<template>
  <div class="page padding">
    <b-card no-body>
      <div class="p-3">
        <h4 class="mb-3">
          {{ nombreProductor }}
          <br />
          <small>Consulta de Comisiones y Retenciones</small>
        </h4>
      </div>
      <b-row class="pl-3 pr-3">
        <b-col sm="3">
          <label class="mr-2">Tipo de Informe</label>
          <b-select id="type-select" class="mb-1 mr-sm-2 mb-sm-0" v-model="params.type" :options="types" @change="colsParaExportar()">
            <template v-slot:first>
              <b-form-select :value="null" disabled>-- Seleccione tipo de informe --</b-form-select>
            </template>
          </b-select>
        </b-col>      
        <b-col v-if="$role(['organizador', 'empleado interno'])">
          <label class="mr-2">Productor</label>
          <!-- <b-select id="type-select" class="mb-2 mr-sm-2 mb-sm-0" v-model="params.producer" :options="$store.getters.productores">
            <template v-slot:first>
              <b-form-select :value="null" disabled>-- Seleccione Productor --</b-form-select>
            </template>
          </b-select> -->
          <v-select
            id="type-select"
            class="mb-1 mr-sm-2 mb-sm-0"
            v-if="$role(['organizador'])"
            v-model="params.producer"
            :options="$store.getters['productores']"
            label="text"
          ></v-select>

          <v-select
            id="type-select"
            class="mb-1 mr-sm-2 mb-sm-0"
            v-else
            v-model="params.producer"
            :options="$store.getters['productoresComisionesRetenciones']"
            label="text"
          ></v-select>
        </b-col>      
        <b-col class="pr-3" v-if="params.type=='Cuenta Corriente'">
        <label for="currency-select">Moneda</label>  
        <b-select
            lg="12"
            id="currency-select"
            class="mb-1 mr-sm-2 mb-sm-0"            
            v-model="params.moneda"
            :options="['Pesos', 'Dolares']"
            label="text"
          ></b-select>
        </b-col>        
        <b-col v-if="params.type=='Cuenta Corriente'">          
          <b-form-checkbox            
            id="checkbox-1"
            v-model="periodo"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
            style="margin-top: 24px" >          
          Por Periodo  
          </b-form-checkbox>          
        </b-col>
      </b-row>
      <b-row class="pl-3 pr-3 pt-3" >
        <b-col sm="3"></b-col>
        
        <b-col sm="3"></b-col>
      </b-row>
      <b-row class="pl-3 pr-3">
        <b-row class="pl-3 pr-3" sm="8" v-if="!periodo || params.type!='Cuenta Corriente'">
          <b-col sm="6">
            <label class="mr-2">Mes</label>
            <b-select id="month-select" class="mb-1 mb-sm-0" placeholder="Mes" v-model="params.month" :options="months">
              <template v-slot:first>
               <b-form-select :value="null" disabled>-- Seleccione mes --</b-form-select>
              </template>
            </b-select>
          </b-col>
          <b-col sm="6">
            <label class="mr-2">Año</label>
              <b-select id="yearSelect" class="mb-1 mb-sm-0" placeholder="Año" v-model="params.year" :options="years">
                <template v-slot:first>
                  <b-form-select :value="null" disabled>-- Seleccione año --</b-form-select>
                </template>
              </b-select>        
          </b-col>
        </b-row>     
        <b-row class="pl-3 pr-3" sm="8" v-if="periodo && params.type=='Cuenta Corriente'">
           <b-col sm="6" class="pl-3 pr-3">
             <label for="example-datepicker1">Desde...</label>
             <date-picker 
                 id="example-datepicker1" 
                 v-model="params.dateFrom" 
                 :config="{format: 'MM/YYYY',useCurrent: false, minDate: mindate}" 
                 class="mb-1 mb-sm-0"
                 autocomplete="off"
                 @dp-change="validarPeriodo"/>          
            </b-col>
        <b-col sm="6">      
          <label for="example-datepicker2">Hasta...</label>
          <date-picker 
             id="example-datepicker2" 
             v-model="params.dateTo" 
             :config="{format: 'MM/YYYY',useCurrent: false, minDate: mindate}" 
              class="mb-1 mb-sm-0"
             autocomplete="off"
             @dp-change="validarPeriodo"/>
        </b-col>          
      </b-row>
      <b-col sm="4" class="p-3">
        <b-col rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block" style="margin-top: 12px" sm="2">
          <b-btn class="btn-action" variant="primary" :disabled="loading" @click="fetchResults"> Aceptar </b-btn>
        </b-col>
      </b-col>
      </b-row>              
    </b-card>

    <b-card class="text-center" v-if="loading"> Procesando solicitud... </b-card>
    <b-modal id="exportar-modal" title="Exportar" hide-footer>
      <label for="report-select" class="my-2">Formato de reporte:</label>
      <b-select id="report-select" class="mb-2 mr-sm-2 mb-sm-0" v-model="formato" 
                :options="opcionesExport">            
      </b-select>
      <p class="my-2">Propiedades a mostar en el reporte:</p>
      <b-form-checkbox-group class="ml-5" v-model="reportCols" v-for="(col, index) in selCols" :key="index">                
        <b-form-checkbox class="mb-1" :value="col.key">{{col.label}}</b-form-checkbox>                
      </b-form-checkbox-group>
      <hr>
       <b-tooltip target="exportararchivoButton" triggers="hover" v-if="periodo">          
          Tenga en cuenta que esta opción descargara varios archivos, <br>
          espere un tiempo prudente para cada uno de ellos y revise los mensajes de su navegador.
      </b-tooltip>
      <b-tooltip target="exportararchivoButton" triggers="hover" v-if="!periodo && formato == 'pdf'">          
          Tenga en cuenta que generar archivos en este formato puede demorar más de lo previsto.<br>
          Por favor espere a que el proceso finalice.
      </b-tooltip>
      <b-button id="exportararchivoButton" variant="success" @click="exportTo()" :disabled="exporting">Exportar Reporte</b-button>

              <!--b-button size="sm" variant="danger" @click="">
                Cancelar
              </b-button-->
              <!--b-button v-if="params.type === 'Retenciones'" :disabled="!data.length" class="m-1" variant="success" size="sm" @click="exportTo('pdf')"> PDF </b-button>
              <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="exportTo('csv')"> CSV </b-button>
              <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="exportTo('xls')"> XLS </b-button-->
    </b-modal>

    <b-modal id="totales-modal" :title="'Saldo Anterior: '+currencySim+totales.saldoAcumuladoInicio" ok-only ok-variant="success" ok-title="Exportar" @ok="downloadExportar" :ok-disabled="downloadTotales">
      <table class="table table-striped">
        <thead>
          <tr class="bg-success"><th>Descripcion</th><th style="text-align: right">Importe</th></tr>
        </thead>
        <tbody>
          <tr><td style="font-weight: bold;">Saldo Acumulado Inicio:</td><td style="text-align: right">{{currencySim}} {{totales.saldoAcumuladoInicio}}</td></tr>
          <tr><td style="font-weight: bold;">Comision Acreditada:</td><td style="text-align: right">{{currencySim}} {{totales.comisionAcreditada}}</td></tr>       
          <!--tr><td>Comision de Cobranza: </td><td style="text-align: right">{{totales.comisiondeCobranza}}</td></tr-->
          <tr><td style="font-weight: bold;">Servicios Sociales: </td><td style="text-align: right">{{currencySim}} {{totales.serviciosSociales}}</td></tr>
          <tr><td style="font-weight: bold;">Ret. Ingresos Brutos: </td><td style="text-align: right">{{currencySim}} {{totales.retIngresosBrutos}}</td></tr>
          <tr><td style="font-weight: bold;">Otros Debitos/Creditos: </td><td style="text-align: right">{{currencySim}} {{totales.otrosDebitosCreditos}}</td></tr>
          <tr><td style="font-weight: bold;">Ganancias: </td><td style="text-align: right">{{currencySim}} {{totales.ganancias}}</td></tr>
          <tr><td style="font-weight: bold;">Ret. IVA / GAN / Monotr.: </td><td style="text-align: right">{{currencySim}} {{totales.retIVAGANMonotr}}</td></tr>       
        </tbody>
        <tfoot>
          <tr class="bg-warning text-dark" style="border-top:solid black 1px"><td><b>Total: </b></td><td style="text-align: right">{{currencySim}} {{totales.total}}</td></tr>       
        </tfoot>
      </table>      
      <hr>   
    </b-modal>

    <b-card no-body v-if="data.length && !loading">
      <b-card-header class="p-0">
        <b-row>
          <b-col>
            <p class="mx-3 my-2">
              Resultados <b>{{ params.type }}</b>
            </p>
          </b-col>
          <!--b-col>
            <table v-if="params.type=='Cuenta Corriente'" style="border: 1px solid white; border-spacing: 4px; ">
              <tbody style="background-color: teal; color: white;">
                <tr><td>Saldo Acumulado Inicio:</td><td style="text-align: right">{{totales.saldoAcumuladoInicio}}</td></tr>
                <tr><td>Salto Anterior en Pesos:</td><td style="text-align: right">{{totales.saldoAcumuladoInicioPesos}}</td></tr>    
              </tbody>
            </table>
          </b-col-->
          <b-col class="text-right">            
            <!--span class="m-3">Exportar:</span-->
            <!-- Desactiamos el PDF temporalmente -->
            <b-button v-if="params.type === 'Cuenta Corriente'" class="btn-success m-2" @click="totalesShow">TOTALES</b-button>            
            <b-button class="btn-success m-2" @click="exportarShow">Exportar...</b-button>            
            
          </b-col>
        </b-row>
      </b-card-header>

      <cuenta-corriente-table 
            :results="data" 
            :saldoAcumuladoInicio="currencySim+' '+totales.saldoAcumuladoInicio" 
            :saldoAcumuladoInicioPesos="'$ '+totales.saldoAcumuladoInicioPesos" 
            v-if="params.type === 'Cuenta Corriente'"/>
      <retenciones-table :data="data" v-if="params.type === 'Retenciones'" />
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';
import CuentaCorrienteTable from '@/components/Pas/CuentaCorrienteTable.vue';
import RetencionesTable from '@/components/Pas/RetencionesTable.vue';

export default {
  components: {
    CuentaCorrienteTable: CuentaCorrienteTable,
    RetencionesTable: RetencionesTable,
  },
  data() {
    return {
      mindate: moment(`${(new Date()).getFullYear()-2}-1-1`, 'YYYY-MM-DD'),
      periodo: false,
      loading: false,
      exporting: false,
      downloadTotales: false,
      totales: {
       saldoAcumuladoInicio: 0,
       saldoAcumuladoInicioPesos: 0,
       comisionAcreditada: 0,       
       comisiondeCobranza: 0,
       serviciosSociales: 0,
       retIngresosBrutos: 0,
       otrosDebitosCreditos: 0,
       ganancias: 0,
       retIVAGANMonotr: 0,
       total: 0
      },
      params: {
        month: null,
        type: null,
        producer: null,
        year: null,
        dateFrom: null,
        dateTo: null,
        moneda: ''
      },
      payload:{},
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      types: ['Retenciones', 'Cuenta Corriente'],
      cc_columns: CuentaCorrienteTable.data().columns,
      rt_columns: RetencionesTable.data().columns,
      selCols: [],
      reportCols: [],
      formato: 'pdf',
      data: [],
      opcionesExport: [
        { text: 'PDF', value: 'pdf' },
        { text: 'TXT', value: 'txt' },
        { text: 'XLS', value: 'xls' },
        { text: 'CSV', value: 'csv' },
      ]
    };
  },
  created() {
    //this.cc_columns = CuentaCorrienteTable.data().columns;
  },
  computed: {
    nombreProductor() {
      return this.$store.getters['NOMBRE_PRODUCTOR'];
    },
    years() {
      const current = parseInt(moment().format('Y'));
      return [current - 2, current - 1, current];
    },
    currencySim(){
      return this.params.moneda == 'Pesos'? '$': 'U$D';
    }
  },
  methods: {
    downloadExportar(e){
      e.preventDefault();
      this.downloadTotales = true;
      this.payload.exportTotales = true;
        this.$api({
              url: this.getFetchUrl(),
              method: 'POST',
              data: this.payload,
              responseType: 'blob',
              headers: {
                  ContentType: 'multipart/form-data',
              },
              })
              .then(res => {                
                  this.downloadTotales = false;
                  const downloadLink = document.createElement('a');
                  const fileURL = URL.createObjectURL(res.data);
                  downloadLink.href = fileURL;
                  downloadLink.download = 'totales';
                  downloadLink.click();
                  window.URL.revokeObjectURL(fileURL);
                  document.body.removeChild(downloadLink); 
                  this.payload.exportTotales = false;
              });
    },
    exportarShow(){
      this.$bvModal.show('exportar-modal');      
    },
    totalesShow(){      
      this.$bvModal.show('totales-modal');
    },
    getStartEndFromDate(date){
       const resultantDate = date;
       
       const fec_desde = moment(resultantDate, 'YYYYMM').startOf('month').format('YMMDD');
       const fec_hasta = moment(resultantDate, 'YYYYMM').endOf('month').format('YMMDD');

       return [fec_desde, fec_hasta];
    },
    getMonthFrom(){
      const fDesde = this.params.dateFrom.split('/');
      const resultantDateDesde = fDesde[1] + ('00' + fDesde[0]).substr(-2);
      const fechaDesde = moment(resultantDateDesde, 'YYYYMM').startOf('month').format('YMMDD');      
      return [resultantDateDesde, fechaDesde];
    },
    getMonthTo(){
      const fHasta = this.params.dateTo.split('/');
      const resultantDateHasta = fHasta[1] + ('00' + fHasta[0]).substr(-2);
      const fechaHasta = moment(resultantDateHasta, 'YYYYMM').endOf('month').format('YMMDD');      
      return [resultantDateHasta, fechaHasta];
    },
    validarPeriodo(){      
      if (this.params.dateFrom == null || this.params.dateTo == null ) return;
      const [resultantDateDesde, fechaDesde] = this.getMonthFrom();
      const [resultantDateHasta, fechaHasta] = this.getMonthTo();
      
      const currentDate = parseInt(moment().format('YYYYMM'));

      //console.log(fechaDesde);
      //console.log(fechaHasta);
      const dif = resultantDateHasta - resultantDateDesde;
      //console.log(dif);
      if(dif < 0) this.$toast.error('La fecha final no puede ser anterior a la fecha inicial.', 'Error');
      else if((dif > 12  && dif < 89) || dif > 99) this.$toast.error('El periodo seleccionado debe ser de entre 2 (dos) a 12 (doce) meses.', 'Error');
           else if (currentDate <= parseInt(resultantDateHasta)) 
                  this.$toast.error('¡Error! ¡Se está especificando un mes que aún no ha vencido!');
      return (!(dif < 0) && !((dif > 12  && dif < 89) || dif > 99) && !(currentDate <= parseInt(resultantDateHasta)));

    },
    colsParaExportar(){      
      this.selCols = this.params.type === 'Cuenta Corriente'? this.cc_columns : this.rt_columns;
      this.reportCols = this.selCols.map(x => x.checked==true?x.key:null).filter(x => x != null);
      //console.log(this.reportCols);
    },
    cod_tipo_agente (producer) {
      return this.$store.getters.productores.filter(prod => prod.value == producer)[0].cod_tipo_agente;
    },
    exportTo: async function (extension = '') {      
      extension = this.formato;
      //console.log('exportar');
      if (this.reportCols.length == 0){
        this.$toast.error('Seleccione al menos un campo para poder exportar.', 'Error');
        return;
      }
      // Cuenta corriente
      /*if (this.params.type === 'Cuenta Corriente') {

        url = 'pas/cuenta-corriente-prod';
        if ( this.$role(['organizador']) ) {
          if(this.$store.state.auth.cod_agente == this.params.producer.value){
            url = 'pas/cuenta-corriente-org/' + this.params.producer.value;
          }
        } else if (this.$role(['empleado interno'])) {
          url = this.params.producer.cod_tipo_agente==2 ? 'pas/cuenta-corriente-org/' + this.params.producer.value : 'pas/cuenta-corriente-prod';
        }
      } else {
        // Retenciones
        url = 'pas/certificados-retencion-prod';
        if ( this.$role(['organizador']) ) {
          if(this.$store.state.auth.cod_agente == this.params.producer.value){
            url = 'pas/certificados-retencion-org';
          }
        } else if (this.$role(['empleado interno'])) {
          url = this.params.producer.cod_tipo_agente==2 ? 'pas/certificados-retencion-org' : 'pas/certificados-retencion-org';
        }

      }*/
      let url = this.getFetchUrl();

      const month = this.months.indexOf(this.params.month);
      const resultantDate = this.params.year + ('00' + (month + 1)).substr(-2);

      const fecha = moment(resultantDate, 'YYYYMM').endOf('month').format('YMMDD');
      const fec_desde = moment(resultantDate, 'YYYYMM').startOf('month').format('YMMDD');
      const fec_hasta = moment(resultantDate, 'YYYYMM').endOf('month').format('YMMDD');

      const data = Object.assign({}, this.params);
      data.output = extension;
      data.moneda = this.params.moneda;

      data.cod_agente = (data.producer!=null) ? data.producer.value : this.$store.state.auth.cod_agente;
      data.cod_org = this.$store.state.auth.cod_agente;

      data.producer = (data.producer!=null) ? data.producer.value : this.$store.state.auth.cod_agente;

      data.fecha = fecha;
      /*data.fec_desde = fec_desde;
      data.fec_hasta = fec_hasta;*/    
      data.moneda = this.params.moneda;
      data.reportCols = this.reportCols;      

      const downloadRq = (payload) => {  
       this.exporting = true;     
       return this.$api({
        url,
        method: 'POST',
        data: payload,
        responseType: 'blob',
        headers: {
          ContentType: 'multipart/form-data',
        },
      })
        .then((res) => {
          let codAgente = ''
          if (this.$role(['empleado interno']) || this.$role(['organizador'])) {
            codAgente = this.params.producer.value
          }else{
            codAgente = this.$store.state.auth.cod_agente
          }
          this.exporting = false;
          let nombreModulo = this.params.type == 'Retenciones' ? '-RETENCIONES.' : '-CUENTACORRIENTE.'
          let nombreArchivo = codAgente + nombreModulo + extension

          const downloadLink = document.createElement('a');
          const fileURL = URL.createObjectURL(res.data);
          downloadLink.href = fileURL;
          downloadLink.download = nombreArchivo;
          downloadLink.click();
          window.URL.revokeObjectURL(fileURL);
          document.body.removeChild(downloadLink);          
        })
        .catch((err) => {
          /*this.loading = false;
          const toast = this.$toast;
          const fr = new FileReader();
          fr.onload = function () {
            toast.error(fr.result);
          };
          if (err.response.data) fr.readAsText(err.response.data);*/
        });
        }       

        data.fec_desde = !this.periodo? fec_desde
                                      : moment(this.getMonthFrom()[0], 'YYYYMM').startOf('month').format('YMMDD');
        data.fec_hasta = !this.periodo? fec_hasta
                                      : moment(this.getMonthTo()[0], 'YYYYMM').endOf('month').format('YMMDD');
        
        if (this.periodo){          
          let anio_ini = parseInt(moment(this.getMonthFrom()[0], 'YYYYMM').format('YYYY'));        
          const anio_fin = parseInt(moment(this.getMonthTo()[0], 'YYYYMM').format('YYYY'));
          let mes_ini = parseInt(moment(this.getMonthFrom()[0], 'YYYYMM').format('MM'));        
          const mes_fin = parseInt(moment(this.getMonthTo()[0], 'YYYYMM').format('MM'));

          //console.log([anio_ini, anio_fin, mes_ini, mes_fin]);
        
          while(anio_ini<=anio_fin && mes_ini-1 != mes_fin){
             const fechas = this.getStartEndFromDate(anio_ini + ('00' + mes_ini).substr(-2))
             data.fec_desde = fechas[0];
             data.fec_hasta = fechas[1];
             await downloadRq(data);
             //console.log(this.getStartEndFromDate(anio_ini + ('00' + mes_ini).substr(-2)));
             mes_ini++;
             if (mes_ini == 13){
               mes_ini = 1;
               anio_ini++;
             }
          }          
        }else{
          await downloadRq(data);          
        } 
        
               
    },
    getFetchUrl(){      
      let url = '';

      if (this.params.type === 'Cuenta Corriente') {
          // Cuenta corriente
          url = 'pas/cuenta-corriente-prod';
          // //console.log("Estamos en CC: ", url)
          if ( this.$role(['organizador']) ) {
            if (this.$store.state.auth.cod_agente == this.params.producer.value){
              url = 'pas/cuenta-corriente-org/' + this.params.producer.value;
            }
            // //console.log("Si fuera organizador: ", url)
          } else if (this.$role(['empleado interno'])) {
            url = this.params.producer.cod_tipo_agente==2 ? 'pas/cuenta-corriente-org/' + this.params.producer.value : 'pas/cuenta-corriente-prod';
            // //console.log("Si fuera empleado interno: ", url)
          }
      }else {
          // Retenciones
          url = 'pas/certificados-retencion-prod';
          if ( this.$role(['organizador']) ) {
            if(this.$store.state.auth.cod_agente == this.params.producer.value){
              url = 'pas/certificados-retencion-org';
            }
          } else if (this.$role(['empleado interno'])) {
            url = this.params.producer.cod_tipo_agente==2 ? 'pas/certificados-retencion-org' : 'pas/certificados-retencion-prod';
          }
      }
      return url;   
    },
    async fetchResults() {
      //console.log('llama esto');
      if (this.periodo){
        if (!this.validarPeriodo()) return;

        this.$bvModal.show('exportar-modal');
        return;
      }
      this.loading = true;
      var currentDate = new Date();
      const params = {};
      const month = this.months.indexOf(this.params.month);
      const resultantDate = this.params.year + ('00' + (month + 1)).substr(-2);

      if(!this.params.type){
        this.$toast.error('¡Error! ¡No se ha elegido ningún tipo de reporte para la búsqueda!')
        this.loading = false
        return null
      }     

      if(!this.params.producer && !this.$role(['Productor', 'Grupo Norte'])){
        this.$toast.error('¡Error! ¡No se ha elegido ningún productor para la búsqueda!')
        this.loading = false
        return null
      }
      
      if(!this.periodo)
      if(this.params.month && this.params.year){
        if((month+1) >= (currentDate.getMonth()+1) && this.params.year == currentDate.getFullYear()) {
          this.$toast.error('¡Error! ¡Se está especificando un mes que aún no ha vencido!')
          this.loading = false
          // loadScreen.hide()
          return null
        }
      }else{
        this.$toast.error('¡Error! ¡No se ha especificado el mes o el año para la búsqueda!')
        this.loading = false
        return null
      }      

      //console.log(this.periodo);
      params.moneda = this.params.moneda;

      params.fec_desde = !this.periodo? moment(resultantDate, 'YYYYMM').startOf('month').format('YMMDD')
                                      : moment(this.getMonthFrom()[0], 'YYYYMM').endOf('month').format('YMMDD');
      params.fec_hasta = !this.periodo? moment(resultantDate, 'YYYYMM').endOf('month').format('YMMDD')
                                      : moment(this.getMonthTo()[0], 'YYYYMM').endOf('month').format('YMMDD');
      params.cod_agente = (this.params.producer!=null) ? this.params.producer.value : this.$store.state.auth.cod_agente;
      
      this.payload = params;
      // //console.log("Parametros: ", params)
      let url = this.getFetchUrl();
      try {
        if (this.params.type === 'Cuenta Corriente') {
          await this.$api.post(url, this.payload).then((res) => {
            this.data = this.$store.state.cuenta_corriente = res.data.registros;
            this.totales = res.data.totales;
            if (this.data.length == 0)
              this.$toast.warning('El periodo seleccionado no contiene movimientos registrados.', 'Alerta');
          });
        } else {          
          await this.$api
            .post(url, {              
              fecha: params.fec_hasta,
              cod_agente: params.cod_agente,
              cod_org: this.$store.state.auth.cod_agente,
            })
            .then((res) => {
              this.data = res.data;
              //console.log(this.data);
              const dist = [];
              this.data.forEach(x => {
                                  if (!dist.includes(x.cod_agente)) dist.push(x.cod_agente);
                               });
              let ordenado = [];
              dist.forEach(x => {
                            const grupo = this.data.filter(y => y.cod_agente == x);
                            ordenado = ordenado.concat(grupo.sort((a, b) => {
                              if (a.impuesto == b.impuesto) return 0;
                              else if(a.impuesto > b.impuesto) return 1;
                                   else return -1;
                            }));
                          });
              this.data = ordenado;
            });
        }
      } catch (err) {
          const fr = new FileReader();
          fr.onload = function () {
            this.$toast.error(fr.result);
          };
          //console.log(err);
        this.$toast.error('Ocurrió un error al enviar solicitud.');
      }

      this.loading = false;
    },
  },
  watch: {
    params: {
      handler() {
        this.results = [];
        this.data = [];
      },
      deep: true,
    },
  },
};
</script>


<style scoped>
@media (max-width: 576px) {
  .btn-action {
    width: 100%;
  }
}
</style>
